
import EpDevPEntityIdsService from "./EpDevPEntityIdsService";
import { 
  TEpCoreCustomAttributeList,
  IEpDevPAttribute, 
  TEpDevPAttributeList,
  TEpCoreCustomAttribute,
  TEpApimAttributeList,
  TEpApimAttribute
} from "./types";

class EpDevPAttributesService {
  private readonly ComponentName = "EpDevPAttributesService";

  public createEmptyObject(generateId: boolean): IEpDevPAttribute {
    return {
      entityId: EpDevPEntityIdsService.createEmptyObject(generateId),
      value: '',
    };
  }
  
  // private validateAttributeValue = (value: string): boolean => {
  //   const schema = $attributes.contains.properties.value;
  //   if(value.length < schema.minLength) return false;
  //   if(value.length > schema.maxLength) return false;
  //   return true;
  // }
  public createEpDevPAttributeFromEpCoreCustomAttribute(epDevPCustomAttribute: TEpCoreCustomAttribute): IEpDevPAttribute {
    return {
      entityId: {
        id: epDevPCustomAttribute.customAttributeDefinitionId,
        displayName: epDevPCustomAttribute.customAttributeDefinitionName
      },
      value: epDevPCustomAttribute.value
    };
  }

  public createEpDevPAttributeListFromEpCoreCustomAttributeList(epCoreParentCustomAttributeList?: TEpCoreCustomAttributeList, epCoreVersionCustomAttributeList?: TEpCoreCustomAttributeList): TEpDevPAttributeList {
    if(epCoreParentCustomAttributeList === undefined && epCoreVersionCustomAttributeList === undefined) return [];
    const parentList = epCoreParentCustomAttributeList ? epCoreParentCustomAttributeList : [];
    const combinedList = epCoreVersionCustomAttributeList ? parentList.concat(epCoreVersionCustomAttributeList) : parentList; 
    return combinedList.map( (x) => {
      return this.createEpDevPAttributeFromEpCoreCustomAttribute(x);
    });
  }

  public createEpDevPAttributeFromEpApimAttribute(epApimAttribute: TEpApimAttribute): IEpDevPAttribute {
    return {
      entityId: {
        id: epApimAttribute.name,
        displayName: epApimAttribute.name
      },
      value: epApimAttribute.value
    };
  }

  public createEpDevPAttributeListFromApimAttributeList(epApimAttributeList?: TEpApimAttributeList): TEpDevPAttributeList {
    if(epApimAttributeList === undefined) return [];
    return epApimAttributeList.map( (x) => {
      return this.createEpDevPAttributeFromEpApimAttribute(x);
    });
  }

  public createCopyOfEpDevPAttributeList(epDevPAttributeList: TEpDevPAttributeList): TEpDevPAttributeList {
    return JSON.parse(JSON.stringify(epDevPAttributeList));
  }

  public createEpCoreCustomAttribute(epDevPAttribute: IEpDevPAttribute): TEpCoreCustomAttribute {
    const funcName = 'createEpCoreCustomAttribute';
    const logName = `${this.ComponentName}.${funcName}()`;
    // validate value is not empty
    if(epDevPAttribute.entityId.id === epDevPAttribute.entityId.displayName) {
      // this is not a core custom attribute
      throw new Error(`${logName}: invalid ep core custom attribute passed, attribute=${JSON.stringify(epDevPAttribute)}`);
    }
    return {
      customAttributeDefinitionId: epDevPAttribute.entityId.id,
      customAttributeDefinitionName: epDevPAttribute.entityId.displayName,
      value: epDevPAttribute.value
    };    
  }

  public createEpCoreCustomAttributeList( epDevPAttributeList: TEpDevPAttributeList ): TEpCoreCustomAttributeList {
    return epDevPAttributeList.map( (x) => {
      return this.createEpCoreCustomAttribute(x);
    });
  }

  public addEpDevPAttributeToEpDevPAttributeList({ epDevPAttribute, epDevPAttributeList }:{
    epDevPAttribute: IEpDevPAttribute;
    epDevPAttributeList: TEpDevPAttributeList;
  }): TEpDevPAttributeList {
    epDevPAttributeList.push(epDevPAttribute);
    return epDevPAttributeList;
    // return APEntityIdsService.sort_ApDisplayObjectList_By_DisplayName(apAttributeDisplayList);
  }

  public removeEpDevPAttributeFromEpDevPAttributeList({ epDevPAttribute, epDevPAttributeList }:{
    epDevPAttribute: IEpDevPAttribute;
    epDevPAttributeList: TEpDevPAttributeList;
  }): TEpDevPAttributeList {
    const idx = epDevPAttributeList.findIndex( (x) => {
      return x.entityId.id === epDevPAttribute.entityId.id;
    });
    if(idx > -1) epDevPAttributeList.splice(idx, 1);
    return epDevPAttributeList;
  }

  public isEmptyEpDevPAttribute(epDevPAttribute: IEpDevPAttribute): boolean {
    return (epDevPAttribute.entityId.id === '');
  }

  public existsIdInEpDevPAttributeList({ id, epDevPAttributeList }:{
    id: string;
    epDevPAttributeList: TEpDevPAttributeList;
  }): boolean {
    const found: IEpDevPAttribute | undefined = epDevPAttributeList.find( (x) => {
      return x.entityId.id === id;
    });
    return (found !== undefined);
  }

  public getEpDevPAttributeByIdFromEpDevPAttributeList({ id, epDevPAttributeList }:{
    id: string;
    epDevPAttributeList: TEpDevPAttributeList;
  }): IEpDevPAttribute | undefined {
    return epDevPAttributeList.find( (x) => {
      return x.entityId.id === id;
    });
  }

  // /**
  //  * Extracts attribute names NOT prefixed with prefix.
  //  * 
  //  * @param apAttributeDisplayList - modified without the extracted attributes 
  //  * @returns 
  //  */
  // public extract_Not_Prefixed_With({ not_prefixed_with, apAttributeDisplayList }:{
  //   not_prefixed_with: string;
  //   apAttributeDisplayList: TAPAttributeDisplayList;
  // }): TAPAttributeDisplayList {
  //   // const funcName = 'extract_Not_Prefixed_With';
  //   // const logName = `${this.BaseComponentName}.${funcName}()`;

  //   const not_prefixed_list: TAPAttributeDisplayList = [];
  //   // alert(`${logName}: before deleting, apAttributeDisplayList=${JSON.stringify(apAttributeDisplayList)}`);
  //   for(let idx=0; idx<apAttributeDisplayList.length; idx++) {
  //     if(!apAttributeDisplayList[idx].apEntityId.id.startsWith(not_prefixed_with)) {
  //       not_prefixed_list.push(apAttributeDisplayList[idx]);
  //       apAttributeDisplayList.splice(idx, 1);
  //       idx--;
  //     }
  //   }
  //   // alert(`${logName}: after deleting idxList, apAttributeDisplayList=${JSON.stringify(apAttributeDisplayList)}`);
  //   return not_prefixed_list;
  // }

  // /**
  //  * Extracts attribute names prefixed with prefix.
  //  * 
  //  * @param apAttributeDisplayList - modified without the extracted attributes 
  //  * @returns 
  //  */
  //    public extract_Prefixed_With({ prefixed_with, apAttributeDisplayList }:{
  //     prefixed_with: string;
  //     apAttributeDisplayList: TAPAttributeDisplayList;
  //   }): TAPAttributeDisplayList {
  //     const prefixed_list: TAPAttributeDisplayList = [];
  //     for(let idx=0; idx<apAttributeDisplayList.length; idx++) {
  //       if(apAttributeDisplayList[idx].apEntityId.id.startsWith(prefixed_with)) {
  //         prefixed_list.push(apAttributeDisplayList[idx]);
  //         apAttributeDisplayList.splice(idx, 1);
  //         idx--;
  //       }
  //     }
  //     return prefixed_list;
  //   }
  
  public filterEpDevPAttributeListByIdList({ idList, epDevPAttributeList }: {
    idList: Array<string>;
    epDevPAttributeList: TEpDevPAttributeList;
  }): TEpDevPAttributeList {
    return epDevPAttributeList.filter( (x) => {
      return idList.find( (y) => { y === x.entityId.id; })
    });
  }

}

export default new EpDevPAttributesService();
